import React from 'react';
import { Outlet, ScrollRestoration } from 'react-router-dom';

import { PublicFooter } from './PublicFooter';
import { PublicNavbar } from './PublicNavbar';

/**
 * PublicLayout component - Wrapper layout for all public-facing pages
 *
 * Features:
 * - PublicNavbar with responsive navigation
 * - Main content area with Outlet for nested routes
 * - PublicFooter with links and social media
 * - Skip-to-content link for keyboard accessibility
 * - min-h-screen on main element for proper footer positioning
 * - ScrollRestoration: public pages scroll the window, so a new page starts
 *   at the top (or at its #hash), and Back returns to where you were
 */
export function PublicLayout(): React.JSX.Element {
  return (
    <div className="flex min-h-screen flex-col">
      <ScrollRestoration />

      {/* Skip to content link - visible on focus for keyboard navigation */}
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-[100] focus:rounded-md focus:bg-contrast-600 focus:px-4 focus:py-2 focus:text-neutral-50 focus:outline-none focus-visible:ring-state-focus"
      >
        Skip to content
      </a>

      <PublicNavbar />

      <main id="main-content" className="flex-1">
        <Outlet />
      </main>

      <PublicFooter />
    </div>
  );
}

export default PublicLayout;
